export default __webpack_public_path__ + "static/media/pantry1-afterA-1024w.d0033a34.avif";